import React, { useState } from 'react';

import { Provider } from './context';

export default function OfflineStateProvider({ children }: { children: React.ReactNode }) {
  const [isOffline, setIsOffline] = useState(false);
  return <Provider value={{ isOffline, setIsOffline }}>{children}</Provider>;
}
